import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { ScannerIcon, ScannerInputField, ScannerInputWrapper } from './ScannerInput.styles'

const ScannerInput = ({ onScan, value, onChange }) => {
  const { t } = useTranslation()
  const inputRef = useRef(null)
  const lastKeyTime = useRef(0)
  const bufferRef = useRef('')

  useEffect(() => {
    // USB barcode scanner detection via rapid keydown (works without input focus)
    const handleKeyDown = (e) => {
      if (e.target === inputRef.current) return // handled by input onChange

      const now = Date.now()
      if (now - lastKeyTime.current > 100) {
        bufferRef.current = ''
      }
      lastKeyTime.current = now

      if (e.key === 'Enter' && bufferRef.current.length > 3) {
        onScan(bufferRef.current)
        bufferRef.current = ''
      } else if (e.key.length === 1) {
        bufferRef.current += e.key
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [onScan])

  return (
    <ScannerInputWrapper>
      <ScannerIcon viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 5v14M6 5v14M9.5 5v14M12 5v14M15.5 5v14M18 5v14M21 5v14" />
      </ScannerIcon>
      <ScannerInputField
        ref={inputRef}
        type="text"
        inputMode="none"
        placeholder={t('scanner.placeholder')}
        value={value}
        readOnly
      />
    </ScannerInputWrapper>
  )
}

export default ScannerInput
